import {Component, inject, OnInit} from '@angular/core';
import {NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {Header} from "@components/layout/header/header";
import {NavItem} from "@core/models/navitem";
import {SidebarService} from "@core/services/sidebar.service";
import {CustomMenuItem} from "@core/models/custom-menuitem";
import {DynamicIcon} from "@shared/directives/dynamic-icon.directive";
import {filter} from "rxjs";
import {AuthService} from "@core/services/auth.service";
import {environment} from "@environments/environment";
import {SeiService} from "@core/services/sei.service";
import {BotSeiService} from "@core/services/bot-sei.service";
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-main',
  imports: [
    RouterOutlet,
    Header,
    DynamicIcon,
    RouterLink,
    RouterLinkActive,
    NgClass,
  ],
  templateUrl: './main.html',
  styleUrl: './main.css'
})
export class Main implements OnInit {
  activeNavItem: NavItem | null = null;
  breadcrumb: CustomMenuItem[] | undefined;
  isAtHome = true;
  navItems: NavItem[] = [];
  isAdmin = false;
  private sidebarService = inject(SidebarService);
  private router = inject(Router);
  private authService = inject(AuthService);
  protected sei = inject(SeiService);
  // o bot pesquisa em segundo plano: o item do menu mostra o andamento
  protected bot = inject(BotSeiService);
  /** Aberto no painel lateral da extensão (quadro dentro de uma página chrome-extension://). */
  protected readonly noPainel = window.top !== window
    && !!location.ancestorOrigins?.[0]?.startsWith('chrome-extension://');

  ngOnInit() {
    this.navItems = this.sidebarService.items;

    if ((environment as any).local) {
      this.isAdmin = true;
    } else {
      // Reativo: acompanha a lista de permissoes mesmo quando ela chega depois
      // do redirecionamento pos-login (evita precisar de F5 para o menu aparecer)
      this.authService.getPermissions().subscribe(perms => {
        this.isAdmin = !!perms?.includes('administrar_sisnot');
      });
    }

    this.sidebarService.activeItem$.subscribe(activeItem => {
      this.activeNavItem = activeItem;
      this.breadcrumb = this.sidebarService.breadcrumbs;
    });

    this.router.events
      .pipe(
        filter(e => e instanceof NavigationEnd)
      )
      .subscribe((e: NavigationEnd) => {
        this.isAtHome = this.isHomeUrl(e.urlAfterRedirects || e.url);
      });

    this.isAtHome = this.isHomeUrl(this.router.url);
  }

  private isHomeUrl(url: string): boolean {
    const clean = url.split('?')[0].split('#')[0];
    const normalized = clean.endsWith('/') && clean.length > 1 ? clean.slice(0, -1) : clean;

    // todo -> se no futuro existir uma pagina inicial diferente de controle-notificacoes, configurar aqui
    return normalized === '/' || normalized === '/controle-notificacoes';
  }

  goBack() {
    if (!this.breadcrumb || this.breadcrumb.length === 0) {
      // Se não tem breadcrumb, volta para home
      this.router.navigate(['/']).then();
      return;
    }

    if (this.breadcrumb.length === 1) {
      // Se só tem 1 item no breadcrumb, volta para home
      this.router.navigate(['/']).then();
      return;
    }

    // Pega o penúltimo item do breadcrumb
    const parent = this.breadcrumb[this.breadcrumb.length - 2];

    if (parent?.url) {
      this.router.navigate([parent.url]).then();
    } else {
      this.router.navigate(['/']).then();
    }
  }
}
